import React, { useState, useEffect } from "react";
import useAxios from "../../utils/useAxios";

const UserGroceryList = () => {
  const [groceryList, setGroceryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const axiosAPI = useAxios();

  const fetchGroceryList = async () => {
    try {
      const response = await axiosAPI.get(`/api/recipe-management/grocery-list`);
      if (response.data.success) {
        setGroceryList(response.data.groceryList);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching grocery list:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroceryList();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="page-header">
          <h3 className="fw-bold mb-3">Grocery Lists</h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">User Grocery Lists</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Ingredient</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr><td colSpan="5">Loading...</td></tr>
                      ) : groceryList.length > 0 ? (
                        groceryList.map((item, index) => (
                          <tr key={index}>
                            <td>{item.user_name}</td>
                            <td>{item.email}</td>
                            <td>{item.ingredient_name}</td>
                            <td>{item.quantity}</td>
                            <td>{item.unit}</td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="5">No grocery lists found.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserGroceryList;
